module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyName", $$v)
      },
      expression: "ruleForm.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理",
      "prop": "adminUser"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": "",
      "defaultVal": _vm.ruleForm.adminUser ? _vm.ruleForm.adminUser : undefined,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "selectFirst": _vm.userInfo.type == '2',
      "params": {
        ComId: _vm.companyId
      }
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'adminUser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 3,
        id: _vm.companyId
      },
      "keys": {
        label: 'successfulManagerName',
        value: 'successfulManager'
      },
      "defaultVal": _vm.ruleForm.successfulManager,
      "selectFirst": _vm.userInfo.type == '3'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 4,
        id: _vm.companyId
      },
      "keys": {
        label: 'agencyManagerName',
        value: 'agencyManager'
      },
      "defaultVal": _vm.ruleForm.agencyManager,
      "selectFirst": _vm.userInfo.type == '4'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期",
      "prop": "payVisitDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.payVisitDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitDate", $$v)
      },
      expression: "ruleForm.payVisitDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contactUser"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.contactUser),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactUser", $$v)
      },
      expression: "ruleForm.contactUser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.ruleForm.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactPhone", $$v)
      },
      expression: "ruleForm.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "position"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.position),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "position", $$v)
      },
      expression: "ruleForm.position"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情",
      "prop": "payVisitInfo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.payVisitInfo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitInfo", $$v)
      },
      expression: "ruleForm.payVisitInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式：",
      "prop": "payVisitStatus"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "拜访状态"
    },
    model: {
      value: (_vm.ruleForm.payVisitStatus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitStatus", $$v)
      },
      expression: "ruleForm.payVisitStatus"
    }
  }, _vm._l((_vm.visitStatusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.ruleForm.payVisitStatus == 2 || _vm.ruleForm.payVisitStatus == 3) ? _c('el-form-item', {
    attrs: {
      "label": "现场照片",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "size": "small",
      "multiple": "",
      "accept": "image/png,image/jpg,image/jpeg,image/gif",
      "auto-upload": false,
      "action": "",
      "on-remove": _vm.handleRemove,
      "on-change": _vm.handerUploadChange,
      "file-list": _vm.fileList,
      "list-type": "picture-card"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47819fd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/TrackManage/ModalForm.vue
// module id = 1736
// module chunks = 9